import React, { useState, useEffect } from "react";
import "../admin/style/header.css";
import Logo from "../images/Collagelogo.png"
import { useNavigate } from "react-router-dom"; // Import useNavigate

const Header = () => {
  const navigate = useNavigate(); // Initialize useNavigate

  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleScroll = () => {
    const offset = window.scrollY;
    if (offset > 50) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);

    // Get the first element with the class 'nav'
    let navigation = document.querySelector(".nav");
    if (navigation.style.display === "none" || navigation.style.display === "") {
      navigation.style.display = "flex";
    } else {
      navigation.style.display = "none";

    }
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="app-container">
      <header className={`header ${isScrolled ? "scrolled" : ""}`}>
        <div className="logo">
          <img src={Logo} alt="" />
        </div>
        <div className={`nav ${isMenuOpen ? "open" : ""}`}>
          <ul className="list1">
            <li onClick={() => navigate("/")}><div id="menu"> Home</div></li>
            <li onClick={() => navigate("/Contactus")}><div id="menu">ContactUs</div></li>
            <li id="button" onClick={() => navigate("/Admin")}><div id="menu">Admin</div></li>
          </ul>
          <ul className="list2">
            <li onClick={() => navigate("/Departments")}><div id="menu">Departments</div></li>
            <li onClick={() => navigate("/Events")}><div id="menu">Events</div></li>
            <li onClick={() => navigate("/Acadamics")}><div id="menu">Acadamics</div></li>
            <li onClick={() => navigate("/Hostel")}><div id="menu">Hostel</div></li>
            <li onClick={() => navigate("/Aboutus")}><div id="menu">AboutUs</div></li>
          </ul>
        </div>
        <div
          className={`hamburger ${isMenuOpen ? "close-icon" : ""}`} onClick={toggleMenu}>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>
      </header>
    </div>
  );
};

export default Header;